/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsContainerV2: {
  name: 'container-v2';
  data: string;
} = {
  name: 'container-v2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v2.98a.99.99 0 0 0 0 .038V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2.98a.81.81 0 0 0 0-.038V4a2 2 0 0 0-2-2H4Zm0 16v2h16v-2H4Zm13.14-2H4V8.7L17.14 16ZM20 4v2H4V4h16Zm0 4H6.86L20 15.3V8Z" fill="currentColor"/></svg>`,
};
